<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <app-title>Commissions Review</app-title>

        <v-dialog v-model="dialog">
          <v-card>
            <import-payment></import-payment>
          </v-card>
        </v-dialog>
        <commissions-runs
          ref="runChooser"
          @runSelected="chooseRun"
          v-model="run"
        ></commissions-runs>
        <v-row>
          <h2>
            {{ run.runType == 1 ? "Initial" : "Royalty" }}
            Run: {{ run.runId }}
          </h2>
        </v-row>
        <v-col v-if="run.runId">
          <v-btn color="primary" @click="ApproveRun(run)">
            {{ run.approvedToPay ? `Remove Approval` : `Approve for Payment` }}
          </v-btn>
          <v-btn color="primary" @click="dialog = true">Import Payments</v-btn>
        </v-col>

        <list-commissions
          @makeInitials="chooseRun"
          @refresh="chooseRun"
        ></list-commissions>
        <commissions-Review ref="Review"></commissions-Review>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import commissionsReview from "@/components/commissions/commissionsReview";
import commsRuns from "@/components/app/commsRuns";
import listCommissions from "@/views/list-commissions";
import importPayment from "@/views/import-payment";
export default {
  name: "commissionsReviewView",
  data() {
    return {
      dialog: false
    };
  },
  components: {
    "commissions-Review": commissionsReview,
    "commissions-runs": commsRuns,
    "list-commissions": listCommissions,
    "import-payment": importPayment
  },
  mounted() {
    if (this.run.runId == 0) {
      this.chooseRun(this.run);
    }
  },
  computed: {
    ...mapState("commissions", ["run"])
  },
  methods: {
    ...mapActions("commissions", ["DownloadReports"]),
    chooseRun() {
      this.$refs.Review.loadData(this.run);
    },
    ApproveRun(val) {
      this.$refs.Review.ApproveToPay(val).then(() => {
        this.$refs.Review.loadData(this.run);
      });
    },
    Download(value) {
      this.DownloadReports(value)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${value.runType == 1 ? "Initial" : "Royalty"}Commissions${
              this.run.runId
            }.zip`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped></style>
